import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Collapse } from "reactstrap";
import { FaLockOpen, FaInfoCircle } from "react-icons/fa";

import ConstData from "../../../lib/ConstData";
import Alerts from "../../etc/list/Alerts";
// 20260828 라이트 로컬 서버 이름/메모 인라인 수정용 공용 컴포넌트
import InlineEditCell from "../common/InlineEditCell";

// 20260828 로컬 서버 관리 화면과 동일하게 상세정보/상세설정 패널로 재배치
// - 상세정보(읽기전용): 생성일 / 방송시작·접속시각 / 초기화 여부 / 공개 여부 / IP 주소
// - 상세설정: 메모(연필 아이콘 인라인 수정) - 라이트 로컬 서버는 로컬 서버와 달리 로그인 허용 등의
//   별도 권한 컬럼이 없어 상세설정에는 메모만 위치한다.
const WebLiteServerInfo = ({ idx, liteServer_info, handleSelectedFunc }) => {
    const { t } = useTranslation();

    const [isDetailInfoOpen, setIsDetailInfoOpen] = useState(false);
    const [isConfigOpen, setIsConfigOpen] = useState(false);

    const toggleDetailInfo = () => setIsDetailInfoOpen(!isDetailInfoOpen);
    const toggleConfig = () => setIsConfigOpen(!isConfigOpen);

    // 20260828 이름 인라인 수정 결과를 로컬 서버 관리 화면의 상세설정 저장과 동일하게 해당 행에서만 표시한다 (2.5초 후 자동 숨김)
    const [nameAlert, setNameAlert] = useState({ kind: ConstData.ALERT_KIND.NONE, message: "" });

    useEffect(() => {
        if (!liteServer_info.nameAlertEventId) return;
        setNameAlert({ kind: liteServer_info.nameAlertKind, message: liteServer_info.nameAlertMessage });
        const timer = setTimeout(() => setNameAlert({ kind: ConstData.ALERT_KIND.NONE, message: "" }), 2500);
        return () => clearTimeout(timer);
    }, [liteServer_info.nameAlertEventId]);

    // 260804 상세정보(생성일 제외) NULL 값은 "-"로 표시 (로컬 서버 관리 화면과 동일한 규칙)
    const formatOrDash = (value) => (value !== undefined && value !== null && value !== "" ? value : "-");

    // 20260828 라이트 로컬 서버 이름 인라인 수정 - 연필 아이콘 확인 클릭 시 즉시 저장
    const onHandleChangeServerName = (newName) => {
        handleSelectedFunc({ selectedFunc: "CHANGE_LITE_SERVER_NAME", data: { liteServerSeq: liteServer_info.liteServerSeq, authCode: liteServer_info.authCode, liteServerName: newName } });
    }

    // 20260828 라이트 로컬 서버 메모 인라인 수정 - 연필 아이콘 확인 클릭 시 즉시 저장 (기존 UPDATE_LITE_SERVER 액션 재사용)
    const onHandleChangeMemo = (newMemo) => {
        handleSelectedFunc({ selectedFunc: "UPDATE_LITE_SERVER", data: { liteServerSeq: liteServer_info.liteServerSeq, authCode: liteServer_info.authCode, memo: newMemo } });
    }

    const onHandleInitServer = () => {
        handleSelectedFunc({ selectedFunc: "INIT_LITE_SERVER", data: { liteServerSeq: liteServer_info.liteServerSeq, authCode: liteServer_info.authCode, initStatus: "Y" } });
    }

    return (
        <>
            {/* teacher/class, 로컬 서버 관리 화면과 동일한 list-table 행 스타일 */}
            <tr>
                <td className="text-center">
                    <span className="d-inline-flex align-items-center justify-content-center">
                        <span className="info content hiclass-num-text lite-server-seq">{liteServer_info.liteServerSeq}</span>
                        {/* 20260828 상세정보(읽기전용: 생성일/방송시작·접속시각/초기화 여부/공개 여부/IP) 토글 아이콘 */}
                        <FaInfoCircle className="font-sm grey-text ml-1 button" style={{ verticalAlign: 'middle', flexShrink: 0 }} onClick={toggleDetailInfo} title={t("상세정보", { ns: "admin" })} />
                    </span>
                </td>
                {/* 260804 사이트/서버 이름이 길 때 잘리지 않던 문제 수정 - admin-ellipsis-cell/text로 말줄임(...) 처리 */}
                <td className="text-center">
                    <div className="d-flex align-items-center justify-content-center admin-ellipsis-cell">
                        <span className={"info content hiclass-text admin-ellipsis-text" + (liteServer_info.liteLocalSiteSeq === -1 ? " grey-text" : "")} title={liteServer_info.liteLocalSiteName}>{liteServer_info.liteLocalSiteName}</span>
                    </div>
                </td>
                {/* 20260828 서버 이름 옆 연필 아이콘 클릭 시 인라인 입력으로 전환, 확인 클릭 시 즉시 저장 */}
                {/* 20260828 로컬 서버 관리 화면과 동일하게 이름 컬럼을 왼쪽 정렬로 변경 */}
                <td className="text-left local-server-name-cell">
                    <div className="d-flex align-items-center justify-content-start admin-ellipsis-cell">
                        <InlineEditCell
                            value={liteServer_info.liteServerName}
                            textClassName={"info title hiclass-text admin-ellipsis-text" + (liteServer_info.liteLocalSiteSeq === -1 ? " grey-text" : "")}
                            requiredMessage={t("라이트_서버_이름_입력", { ns: "admin" })}
                            onSave={onHandleChangeServerName}
                        />
                        {
                            liteServer_info.publicStatus === "Y" &&
                            <FaLockOpen className="font-md green-text ml-2" style={{ flexShrink: 0 }} title={t("공개가_허용된_수업입니다", { ns: "admin" })} />
                        }
                    </div>
                </td>
                <td className="text-center">
                    <span className="info content small hiclass-text">{liteServer_info.authCode}</span>
                </td>
                <td className="text-center">
                    <div className="d-flex align-items-center justify-content-center flex-wrap" style={{ gap: '4px' }}>
                        <button className="btn-table-action" type="button" onClick={toggleConfig}>
                            {t("상세설정", { ns: "admin" })}
                        </button>
                        <button type="button" className="btn-table-action" title={t("재설정", { ns: "user" })} onClick={() => onHandleInitServer()} disabled={liteServer_info.initStatus === "Y" ? true : false}>
                            {t("재설정", { ns: "user" })}
                        </button>
                    </div>
                </td>
            </tr>
            {/* 20260828 이름 인라인 수정 결과 - 해당 행 바로 아래에서만 표시하고 2.5초 후 사라진다 */}
            {nameAlert.kind !== ConstData.ALERT_KIND.NONE &&
                <tr className="b-none local-server-detail-row">
                    <td colSpan={5} className="p-0">
                        <div className="d-flex align-items-center justify-content-center w-100">
                            <div className="area-90 mt-1">
                                <Alerts kind={nameAlert.kind} message={nameAlert.message} />
                            </div>
                        </div>
                    </td>
                </tr>
            }
            {/* 20260828 상세정보 - 읽기전용 (생성일/방송시작·접속시각/초기화 여부/공개 여부/IP), 생성일 외에는 NULL이면 "-" 표시 */}
            <tr className="b-none local-server-detail-row">
                <td colSpan={5} className="p-0">
                    <Collapse isOpen={isDetailInfoOpen} className="w-100">
                        <div className="d-flex align-items-center justify-content-center w-100">
                            <div className="area-90 local-server-panel-card mt-2">
                                <div className="d-flex flex-wrap" style={{ gap: '16px' }}>
                                    <div className="d-flex flex-column" style={{ minWidth: '160px' }}>
                                        <span className="font-sm grey-text">{t("생성일", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(liteServer_info.createDt)}</span>
                                    </div>
                                    <div className="d-flex flex-column" style={{ minWidth: '160px' }}>
                                        <span className="font-sm grey-text">{t("방송시작_접속시각", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(liteServer_info.startDateTime)}</span>
                                    </div>
                                    <div className="d-flex flex-column" style={{ minWidth: '160px' }}>
                                        <span className="font-sm grey-text">{t("초기화_여부", { ns: "admin" })}</span>
                                        <span className={`local-server-state-badge server-state-${liteServer_info.initStatus === "Y" ? "online" : "neutral"}`}>{liteServer_info.initStatus === "Y" ? "Y" : "N"}</span>
                                    </div>
                                    <div className="d-flex flex-column" style={{ minWidth: '160px' }}>
                                        <span className="font-sm grey-text">{t("공개_여부", { ns: "admin" })}</span>
                                        <span className={`local-server-state-badge server-state-${liteServer_info.publicStatus === "Y" ? "online" : "neutral"}`}>{liteServer_info.publicStatus === "Y" ? "Y" : "N"}</span>
                                    </div>
                                    <div className="d-flex flex-column" style={{ minWidth: '160px' }}>
                                        {/* 20260828 다국어 키 통일: IP_Address -> IP_주소 */}
                                        <span className="font-sm grey-text">{t("IP_주소", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(liteServer_info.ipAddress)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                </td>
            </tr>
            {/* 20260828 상세설정 - 메모 인라인 수정 (연필 아이콘 확인 클릭 시 즉시 저장) */}
            <tr className="b-none local-server-detail-row">
                <td colSpan={5} className="p-0">
                    <Collapse isOpen={isConfigOpen} className="w-100">
                        <div className="d-flex align-items-center justify-content-center w-100">
                            <div className="area-90 local-server-panel-card mt-2 mb-2">
                                <div className="local-server-panel-field m-0">
                                    {/* 20260828 다국어 키 통일: Memo -> 메모 */}
                                    <span className="local-server-panel-label">{t("메모", { ns: "admin" })}</span>
                                    {/* 20260828 라벨(위)과 값+연필 아이콘(아래, 가로 정렬)이 분리되도록 별도 flex row로 감싼다 */}
                                    <div className="d-flex align-items-center">
                                        <InlineEditCell
                                            value={liteServer_info.liteServerMemo || ""}
                                            textClassName="local-server-panel-value"
                                            emptyText={t("메모_입력_안내", { ns: "admin" })}
                                            onSave={onHandleChangeMemo}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                </td>
            </tr>
        </>
    );
}

export default WebLiteServerInfo;
